import { modalAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import { Button } from './button.js';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(modalAnatomy.keys);
const borderStyles = {
  background: "linear-gradient(rgba(255, 255, 255, 0),var(--vimeo-colors-surface) 50%) center bottom, linear-gradient(to top, var(--vimeo-colors-stroke), var(--vimeo-colors-stroke)) center bottom",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 40px, 100% 1px",
  backgroundAttachment: "local, scroll",
  overflow: "auto",
  overflowScrolling: "touch"
};
const dialogContainerStyles = defineStyle((props) => {
  const { isCentered, scrollBehavior } = props;
  return {
    height: "100dvh",
    display: "flex",
    justifyContent: "center",
    zIndex: "modal",
    alignItems: isCentered ? "center" : "flex-start",
    overflow: scrollBehavior === "inside" ? "hidden" : "auto"
  };
});
const dialogStyles = defineStyle((props) => {
  const { scrollBehavior } = props;
  return {
    bgColor: "surface",
    color: "black",
    borderRadius: "modal",
    boxShadow: "0 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.2)",
    maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : undefined,
    // Remove rounded corners from body if the modal footer is present so the border styles are not affected.
    ":has(footer)": {
      ".chakra-modal__body": {
        borderBottomRadius: "unset"
      }
    }
  };
});
const bodyStyles = defineStyle((props) => {
  const { scrollBehavior } = props;
  return {
    _dark: { color: "white" },
    paddingBottom: "400",
    paddingRight: "400",
    paddingLeft: "400",
    ...borderStyles,
    overflow: scrollBehavior === "inside" ? "auto" : undefined,
    borderBottomRadius: "xl"
  };
});
const baseStyle = definePartsStyle((props) => ({
  dialog: dialogStyles(props),
  dialogContainer: dialogContainerStyles(props),
  body: bodyStyles(props),
  overlay: {
    bgColor: "rgba(50, 50, 50, 0.667)",
    zIndex: "modal"
  },
  header: {
    fontSize: "header-xl",
    lineHeight: "header-xl",
    fontWeight: "700",
    marginBottom: "1.25rem",
    _dark: {
      color: "white"
    },
    px: "400",
    paddingTop: "400"
  },
  footer: {
    paddingTop: "300",
    paddingBottom: "400",
    paddingLeft: "400",
    paddingRight: "400",
    display: "flex",
    gap: "1rem"
  },
  closeButton: {
    ...Button.baseStyle,
    ...Button.sizes?.sm,
    position: "absolute",
    top: "75",
    right: "75",
    _dark: {
      color: "white"
    }
  }
}));
const sizes = {
  sm: {
    dialog: { maxW: "21.25rem" }
  },
  md: {
    dialog: { maxW: "27.5rem" }
  },
  lg: {
    dialog: { maxW: "41.25rem" }
  }
};
const Modal = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: "md"
  }
});

export { Modal };
